import "./singleplayer.278b3a44.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $ayMG0 = parcelRequire("ayMG0");
let $e88f48828034b730$var$wasm;
function $e88f48828034b730$var$addToExternrefTable0(obj) {
    const idx = $e88f48828034b730$var$wasm.__externref_table_alloc();
    $e88f48828034b730$var$wasm.__wbindgen_export_2.set(idx, obj);
    return idx;
}
function $e88f48828034b730$var$handleError(f, args) {
    try {
        return f.apply(this, args);
    } catch (e) {
        const idx = $e88f48828034b730$var$addToExternrefTable0(e);
        $e88f48828034b730$var$wasm.__wbindgen_exn_store(idx);
    }
}
function $e88f48828034b730$var$isLikeNone(x) {
    return x === undefined || x === null;
}
let $e88f48828034b730$var$cachedDataViewMemory0 = null;
function $e88f48828034b730$var$getDataViewMemory0() {
    if ($e88f48828034b730$var$cachedDataViewMemory0 === null || $e88f48828034b730$var$cachedDataViewMemory0.buffer.detached === true || $e88f48828034b730$var$cachedDataViewMemory0.buffer.detached === undefined && $e88f48828034b730$var$cachedDataViewMemory0.buffer !== $e88f48828034b730$var$wasm.memory.buffer) $e88f48828034b730$var$cachedDataViewMemory0 = new DataView($e88f48828034b730$var$wasm.memory.buffer);
    return $e88f48828034b730$var$cachedDataViewMemory0;
}
function $e88f48828034b730$var$debugString(val) {
    // primitive types
    const type = typeof val;
    if (type == 'number' || type == 'boolean' || val == null) return `${val}`;
    if (type == 'string') return `"${val}"`;
    if (type == 'symbol') {
        const description = val.description;
        if (description == null) return 'Symbol';
        else return `Symbol(${description})`;
    }
    if (type == 'function') {
        const name = val.name;
        if (typeof name == 'string' && name.length > 0) return `Function(${name})`;
        else return 'Function';
    }
    // objects
    if (Array.isArray(val)) {
        const length = val.length;
        let debug = '[';
        if (length > 0) debug += $e88f48828034b730$var$debugString(val[0]);
        for(let i = 1; i < length; i++)debug += ', ' + $e88f48828034b730$var$debugString(val[i]);
        debug += ']';
        return debug;
    }
    // Test for built-in
    const builtInMatches = /\[object ([^\]]+)\]/.exec(toString.call(val));
    let className;
    if (builtInMatches && builtInMatches.length > 1) className = builtInMatches[1];
    else // Failed to match the standard '[object ClassName]'
    return toString.call(val);
    if (className == 'Object') // we're a user defined class or Object
    // JSON.stringify avoids problems with cycles, and is generally much
    // easier than looping through ownProperties of `val`.
    try {
        return 'Object(' + JSON.stringify(val) + ')';
    } catch (_) {
        return 'Object';
    }
    // errors
    if (val instanceof Error) return `${val.name}: ${val.message}\n${val.stack}`;
    // TODO we could test for more things here, like `Set`s and `Map`s.
    return className;
}
let $e88f48828034b730$var$WASM_VECTOR_LEN = 0;
let $e88f48828034b730$var$cachedUint8ArrayMemory0 = null;
function $e88f48828034b730$var$getUint8ArrayMemory0() {
    if ($e88f48828034b730$var$cachedUint8ArrayMemory0 === null || $e88f48828034b730$var$cachedUint8ArrayMemory0.byteLength === 0) $e88f48828034b730$var$cachedUint8ArrayMemory0 = new Uint8Array($e88f48828034b730$var$wasm.memory.buffer);
    return $e88f48828034b730$var$cachedUint8ArrayMemory0;
}
const $e88f48828034b730$var$cachedTextEncoder = typeof TextEncoder !== 'undefined' ? new TextEncoder('utf-8') : {
    encode: ()=>{
        throw Error('TextEncoder not available');
    }
};
const $e88f48828034b730$var$encodeString = typeof $e88f48828034b730$var$cachedTextEncoder.encodeInto === 'function' ? function(arg, view) {
    return $e88f48828034b730$var$cachedTextEncoder.encodeInto(arg, view);
} : function(arg, view) {
    const buf = $e88f48828034b730$var$cachedTextEncoder.encode(arg);
    view.set(buf);
    return {
        read: arg.length,
        written: buf.length
    };
};
function $e88f48828034b730$var$passStringToWasm0(arg, malloc, realloc) {
    if (realloc === undefined) {
        const buf = $e88f48828034b730$var$cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length, 1) >>> 0;
        $e88f48828034b730$var$getUint8ArrayMemory0().subarray(ptr, ptr + buf.length).set(buf);
        $e88f48828034b730$var$WASM_VECTOR_LEN = buf.length;
        return ptr;
    }
    let len = arg.length;
    let ptr = malloc(len, 1) >>> 0;
    const mem = $e88f48828034b730$var$getUint8ArrayMemory0();
    let offset = 0;
    for(; offset < len; offset++){
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }
    if (offset !== len) {
        if (offset !== 0) arg = arg.slice(offset);
        ptr = realloc(ptr, len, len = offset + arg.length * 3, 1) >>> 0;
        const view = $e88f48828034b730$var$getUint8ArrayMemory0().subarray(ptr + offset, ptr + len);
        const ret = $e88f48828034b730$var$encodeString(arg, view);
        offset += ret.written;
        ptr = realloc(ptr, len, offset, 1) >>> 0;
    }
    $e88f48828034b730$var$WASM_VECTOR_LEN = offset;
    return ptr;
}
const $e88f48828034b730$var$cachedTextDecoder = typeof TextDecoder !== 'undefined' ? new TextDecoder('utf-8', {
    ignoreBOM: true,
    fatal: true
}) : {
    decode: ()=>{
        throw Error('TextDecoder not available');
    }
};
if (typeof TextDecoder !== 'undefined') $e88f48828034b730$var$cachedTextDecoder.decode();
function $e88f48828034b730$var$getStringFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return $e88f48828034b730$var$cachedTextDecoder.decode($e88f48828034b730$var$getUint8ArrayMemory0().subarray(ptr, ptr + len));
}
const $e88f48828034b730$var$WasmAPIFinalization = typeof FinalizationRegistry === 'undefined' ? {
    register: ()=>{},
    unregister: ()=>{}
} : new FinalizationRegistry((ptr)=>$e88f48828034b730$var$wasm.__wbg_wasmapi_free(ptr >>> 0, 1));
class $e88f48828034b730$export$9ed775f32f831ad8 {
    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        $e88f48828034b730$var$WasmAPIFinalization.unregister(this);
        return ptr;
    }
    free() {
        const ptr = this.__destroy_into_raw();
        $e88f48828034b730$var$wasm.__wbg_wasmapi_free(ptr, 0);
    }
    /**
     * @param {string} word
     * @returns {any}
     */ add_to_dictionary(word) {
        const ptr0 = $e88f48828034b730$var$passStringToWasm0(word, $e88f48828034b730$var$wasm.__wbindgen_malloc, $e88f48828034b730$var$wasm.__wbindgen_realloc);
        const len0 = $e88f48828034b730$var$WASM_VECTOR_LEN;
        const ret = $e88f48828034b730$var$wasm.wasmapi_add_to_dictionary(this.__wbg_ptr, ptr0, len0);
        return ret;
    }
    /**
     * @param {bigint} seed
     * @param {string} dictionary_text
     * @param {any} ai_difficulties
     */ constructor(seed, dictionary_text, ai_difficulties){
        const ptr0 = $e88f48828034b730$var$passStringToWasm0(dictionary_text, $e88f48828034b730$var$wasm.__wbindgen_malloc, $e88f48828034b730$var$wasm.__wbindgen_realloc);
        const len0 = $e88f48828034b730$var$WASM_VECTOR_LEN;
        const ret = $e88f48828034b730$var$wasm.wasmapi_new(seed, ptr0, len0, ai_difficulties);
        this.__wbg_ptr = ret >>> 0;
        $e88f48828034b730$var$WasmAPIFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @returns {any}
     */ load() {
        const ret = $e88f48828034b730$var$wasm.wasmapi_load(this.__wbg_ptr);
        return ret;
    }
    /**
     * @returns {any}
     */ pass() {
        const ret = $e88f48828034b730$var$wasm.wasmapi_pass(this.__wbg_ptr);
        return ret;
    }
    /**
     * @param {any} tray_tile_locations
     * @param {boolean} commit_move
     * @returns {any}
     */ play(tray_tile_locations, commit_move) {
        const ret = $e88f48828034b730$var$wasm.wasmapi_play(this.__wbg_ptr, tray_tile_locations, commit_move);
        return ret;
    }
    /**
     * @param {any} selection
     * @returns {any}
     */ exchange(selection) {
        const ret = $e88f48828034b730$var$wasm.wasmapi_exchange(this.__wbg_ptr, selection);
        return ret;
    }
}
async function $e88f48828034b730$var$__wbg_load(module, imports) {
    if (typeof Response === 'function' && module instanceof Response) {
        if (typeof WebAssembly.instantiateStreaming === 'function') try {
            return await WebAssembly.instantiateStreaming(module, imports);
        } catch (e) {
            if (module.headers.get('Content-Type') != 'application/wasm') console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve Wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);
            else throw e;
        }
        const bytes = await module.arrayBuffer();
        return await WebAssembly.instantiate(bytes, imports);
    } else {
        const instance = await WebAssembly.instantiate(module, imports);
        if (instance instanceof WebAssembly.Instance) return {
            instance: instance,
            module: module
        };
        else return instance;
    }
}
function $e88f48828034b730$var$__wbg_get_imports() {
    const imports = {};
    imports.wbg = {};
    imports.wbg.__wbg_buffer_609cc3eee51ed158 = function(arg0) {
        const ret = arg0.buffer;
        return ret;
    };
    imports.wbg.__wbg_call_672a4d21634d4a24 = function() {
        return $e88f48828034b730$var$handleError(function(arg0, arg1) {
            const ret = arg0.call(arg1);
            return ret;
        }, arguments);
    };
    imports.wbg.__wbg_codePointAt_78181f32881e5b59 = function(arg0, arg1) {
        const ret = arg0.codePointAt(arg1 >>> 0);
        return ret;
    };
    imports.wbg.__wbg_done_769e5ede4b31c67b = function(arg0) {
        const ret = arg0.done;
        return ret;
    };
    imports.wbg.__wbg_fromCodePoint_f37c25c172f2e8b5 = function() {
        return $e88f48828034b730$var$handleError(function(arg0) {
            const ret = String.fromCodePoint(arg0 >>> 0);
            return ret;
        }, arguments);
    };
    imports.wbg.__wbg_get_67b2ba62fc30de12 = function() {
        return $e88f48828034b730$var$handleError(function(arg0, arg1) {
            const ret = Reflect.get(arg0, arg1);
            return ret;
        }, arguments);
    };
    imports.wbg.__wbg_get_b9b93047fe3cf45b = function(arg0, arg1) {
        const ret = arg0[arg1 >>> 0];
        return ret;
    };
    imports.wbg.__wbg_getwithrefkey_1dc361bd10053bfe = function(arg0, arg1) {
        const ret = arg0[arg1];
        return ret;
    };
    imports.wbg.__wbg_instanceof_ArrayBuffer_e14585432e3737fc = function(arg0) {
        let result;
        try {
            result = arg0 instanceof ArrayBuffer;
        } catch (_) {
            result = false;
        }
        const ret = result;
        return ret;
    };
    imports.wbg.__wbg_instanceof_Uint8Array_17156bcf118086a9 = function(arg0) {
        let result;
        try {
            result = arg0 instanceof Uint8Array;
        } catch (_) {
            result = false;
        }
        const ret = result;
        return ret;
    };
    imports.wbg.__wbg_isArray_a1eab7e0d067391b = function(arg0) {
        const ret = Array.isArray(arg0);
        return ret;
    };
    imports.wbg.__wbg_isSafeInteger_343e2beeeece1bb0 = function(arg0) {
        const ret = Number.isSafeInteger(arg0);
        return ret;
    };
    imports.wbg.__wbg_iterator_9a24c88df860dc65 = function() {
        const ret = Symbol.iterator;
        return ret;
    };
    imports.wbg.__wbg_length_a446193dc22c12f8 = function(arg0) {
        const ret = arg0.length;
        return ret;
    };
    imports.wbg.__wbg_length_d56737991078581b = function(arg0) {
        const ret = arg0.length;
        return ret;
    };
    imports.wbg.__wbg_length_e2d2a49132c1b256 = function(arg0) {
        const ret = arg0.length;
        return ret;
    };
    imports.wbg.__wbg_new_405e22f390576ce2 = function() {
        const ret = new Object();
        return ret;
    };
    imports.wbg.__wbg_new_5e0be73521bc8c17 = function() {
        const ret = new Map();
        return ret;
    };
    imports.wbg.__wbg_new_78feb108b6472713 = function() {
        const ret = new Array();
        return ret;
    };
    imports.wbg.__wbg_new_a12002a7f91c75be = function(arg0) {
        const ret = new Uint8Array(arg0);
        return ret;
    };
    imports.wbg.__wbg_next_25feadfc0913fea9 = function(arg0) {
        const ret = arg0.next;
        return ret;
    };
    imports.wbg.__wbg_next_6574e1a8a62d1055 = function() {
        return $e88f48828034b730$var$handleError(function(arg0) {
            const ret = arg0.next();
            return ret;
        }, arguments);
    };
    imports.wbg.__wbg_set_37837023f3d740e8 = function(arg0, arg1, arg2) {
        arg0[arg1 >>> 0] = arg2;
    };
    imports.wbg.__wbg_set_3f1d0b984ed272ed = function(arg0, arg1, arg2) {
        arg0[arg1] = arg2;
    };
    imports.wbg.__wbg_set_65595bdd868b3009 = function(arg0, arg1, arg2) {
        arg0.set(arg1, arg2 >>> 0);
    };
    imports.wbg.__wbg_set_8fc6bf8a5b1071d1 = function(arg0, arg1, arg2) {
        const ret = arg0.set(arg1, arg2);
        return ret;
    };
    imports.wbg.__wbg_value_cd1ffa7b1ab794f1 = function(arg0) {
        const ret = arg0.value;
        return ret;
    };
    imports.wbg.__wbindgen_as_number = function(arg0) {
        const ret = +arg0;
        return ret;
    };
    imports.wbg.__wbindgen_bigint_from_u64 = function(arg0) {
        const ret = BigInt.asUintN(64, arg0);
        return ret;
    };
    imports.wbg.__wbindgen_bigint_get_as_i64 = function(arg0, arg1) {
        const v = arg1;
        const ret = typeof v === 'bigint' ? v : undefined;
        $e88f48828034b730$var$getDataViewMemory0().setBigInt64(arg0 + 8, $e88f48828034b730$var$isLikeNone(ret) ? BigInt(0) : ret, true);
        $e88f48828034b730$var$getDataViewMemory0().setInt32(arg0 + 0, !$e88f48828034b730$var$isLikeNone(ret), true);
    };
    imports.wbg.__wbindgen_boolean_get = function(arg0) {
        const v = arg0;
        const ret = typeof v === 'boolean' ? v ? 1 : 0 : 2;
        return ret;
    };
    imports.wbg.__wbindgen_debug_string = function(arg0, arg1) {
        const ret = $e88f48828034b730$var$debugString(arg1);
        const ptr1 = $e88f48828034b730$var$passStringToWasm0(ret, $e88f48828034b730$var$wasm.__wbindgen_malloc, $e88f48828034b730$var$wasm.__wbindgen_realloc);
        const len1 = $e88f48828034b730$var$WASM_VECTOR_LEN;
        $e88f48828034b730$var$getDataViewMemory0().setInt32(arg0 + 4, len1, true);
        $e88f48828034b730$var$getDataViewMemory0().setInt32(arg0 + 0, ptr1, true);
    };
    imports.wbg.__wbindgen_error_new = function(arg0, arg1) {
        const ret = new Error($e88f48828034b730$var$getStringFromWasm0(arg0, arg1));
        return ret;
    };
    imports.wbg.__wbindgen_in = function(arg0, arg1) {
        const ret = arg0 in arg1;
        return ret;
    };
    imports.wbg.__wbindgen_init_externref_table = function() {
        const table = $e88f48828034b730$var$wasm.__wbindgen_export_2;
        const offset = table.grow(4);
        table.set(0, undefined);
        table.set(offset + 0, undefined);
        table.set(offset + 1, null);
        table.set(offset + 2, true);
        table.set(offset + 3, false);
    };
    imports.wbg.__wbindgen_is_bigint = function(arg0) {
        const ret = typeof arg0 === 'bigint';
        return ret;
    };
    imports.wbg.__wbindgen_is_function = function(arg0) {
        const ret = typeof arg0 === 'function';
        return ret;
    };
    imports.wbg.__wbindgen_is_object = function(arg0) {
        const val = arg0;
        const ret = typeof val === 'object' && val !== null;
        return ret;
    };
    imports.wbg.__wbindgen_is_string = function(arg0) {
        const ret = typeof arg0 === 'string';
        return ret;
    };
    imports.wbg.__wbindgen_is_undefined = function(arg0) {
        const ret = arg0 === undefined;
        return ret;
    };
    imports.wbg.__wbindgen_jsval_eq = function(arg0, arg1) {
        const ret = arg0 === arg1;
        return ret;
    };
    imports.wbg.__wbindgen_jsval_loose_eq = function(arg0, arg1) {
        const ret = arg0 == arg1;
        return ret;
    };
    imports.wbg.__wbindgen_memory = function() {
        const ret = $e88f48828034b730$var$wasm.memory;
        return ret;
    };
    imports.wbg.__wbindgen_number_get = function(arg0, arg1) {
        const obj = arg1;
        const ret = typeof obj === 'number' ? obj : undefined;
        $e88f48828034b730$var$getDataViewMemory0().setFloat64(arg0 + 8, $e88f48828034b730$var$isLikeNone(ret) ? 0 : ret, true);
        $e88f48828034b730$var$getDataViewMemory0().setInt32(arg0 + 0, !$e88f48828034b730$var$isLikeNone(ret), true);
    };
    imports.wbg.__wbindgen_number_new = function(arg0) {
        const ret = arg0;
        return ret;
    };
    imports.wbg.__wbindgen_string_get = function(arg0, arg1) {
        const obj = arg1;
        const ret = typeof obj === 'string' ? obj : undefined;
        var ptr1 = $e88f48828034b730$var$isLikeNone(ret) ? 0 : $e88f48828034b730$var$passStringToWasm0(ret, $e88f48828034b730$var$wasm.__wbindgen_malloc, $e88f48828034b730$var$wasm.__wbindgen_realloc);
        var len1 = $e88f48828034b730$var$WASM_VECTOR_LEN;
        $e88f48828034b730$var$getDataViewMemory0().setInt32(arg0 + 4, len1, true);
        $e88f48828034b730$var$getDataViewMemory0().setInt32(arg0 + 0, ptr1, true);
    };
    imports.wbg.__wbindgen_string_new = function(arg0, arg1) {
        const ret = $e88f48828034b730$var$getStringFromWasm0(arg0, arg1);
        return ret;
    };
    imports.wbg.__wbindgen_throw = function(arg0, arg1) {
        throw new Error($e88f48828034b730$var$getStringFromWasm0(arg0, arg1));
    };
    return imports;
}
function $e88f48828034b730$var$__wbg_init_memory(imports, memory) {}
function $e88f48828034b730$var$__wbg_finalize_init(instance, module) {
    $e88f48828034b730$var$wasm = instance.exports;
    $e88f48828034b730$var$__wbg_init.__wbindgen_wasm_module = module;
    $e88f48828034b730$var$cachedDataViewMemory0 = null;
    $e88f48828034b730$var$cachedUint8ArrayMemory0 = null;
    $e88f48828034b730$var$wasm.__wbindgen_start();
    return $e88f48828034b730$var$wasm;
}
function $e88f48828034b730$export$2ec80ee76a9348bf(module) {
    if ($e88f48828034b730$var$wasm !== undefined) return $e88f48828034b730$var$wasm;
    if (typeof module !== 'undefined') {
        if (Object.getPrototypeOf(module) === Object.prototype) ({ module: module } = module);
        else console.warn('using deprecated parameters for `initSync()`; pass a single object instead');
    }
    const imports = $e88f48828034b730$var$__wbg_get_imports();
    $e88f48828034b730$var$__wbg_init_memory(imports);
    if (!(module instanceof WebAssembly.Module)) module = new WebAssembly.Module(module);
    const instance = new WebAssembly.Instance(module, imports);
    return $e88f48828034b730$var$__wbg_finalize_init(instance, module);
}
var $43aa522aaedc6267$exports = {};
$43aa522aaedc6267$exports = import.meta.resolve("idb4t");


async function $e88f48828034b730$var$__wbg_init(module_or_path) {
    if ($e88f48828034b730$var$wasm !== undefined) return $e88f48828034b730$var$wasm;
    if (typeof module_or_path !== 'undefined') {
        if (Object.getPrototypeOf(module_or_path) === Object.prototype) ({ module_or_path: module_or_path } = module_or_path);
        else console.warn('using deprecated parameters for the initialization function; pass a single object instead');
    }
    if (typeof module_or_path === 'undefined') module_or_path = new URL($43aa522aaedc6267$exports);
    const imports = $e88f48828034b730$var$__wbg_get_imports();
    if (typeof module_or_path === 'string' || typeof Request === 'function' && module_or_path instanceof Request || typeof URL === 'function' && module_or_path instanceof URL) module_or_path = fetch(module_or_path);
    $e88f48828034b730$var$__wbg_init_memory(imports);
    const { instance: instance, module: module } = await $e88f48828034b730$var$__wbg_load(await module_or_path, imports);
    return $e88f48828034b730$var$__wbg_finalize_init(instance, module);
}
var $e88f48828034b730$export$2e2bcd8739ae039 = $e88f48828034b730$var$__wbg_init;



var $aRPiL = parcelRequire("aRPiL");

var $acw62 = parcelRequire("acw62");

var $mDWTX = parcelRequire("mDWTX");

var $crZ6d = parcelRequire("crZ6d");

class $28275cec89eb94a7$export$9ed775f32f831ad8 {
    wasm;
    constructor(seed, dictionary_text, ais){
        this.wasm = new (0, $e88f48828034b730$export$9ed775f32f831ad8)(seed, dictionary_text, ais);
    }
    add_to_dictionary(word) {
        return new Promise((resolve, reject)=>{
            let api_state = this.wasm.add_to_dictionary(word);
            if ((0, $crZ6d.is_ok)(api_state)) resolve(api_state.Ok);
            else reject(api_state.Err);
        });
    }
    exchange(selection) {
        return new Promise((resolve, reject)=>{
            let api_state = this.wasm.exchange(selection);
            if ((0, $crZ6d.is_ok)(api_state)) resolve(api_state.Ok);
            else reject(api_state.Err);
        });
    }
    load(_wait) {
        return new Promise((resolve, reject)=>{
            let api_state = this.wasm.load();
            if ((0, $crZ6d.is_ok)(api_state)) resolve(api_state.Ok);
            else reject(api_state.Err);
        });
    }
    pass() {
        return new Promise((resolve, reject)=>{
            let api_state = this.wasm.pass();
            if ((0, $crZ6d.is_ok)(api_state)) resolve(api_state.Ok);
            else reject(api_state.Err);
        });
    }
    play(tiles, commit) {
        return new Promise((resolve, reject)=>{
            let api_state = this.wasm.play(tiles, commit);
            if ((0, $crZ6d.is_ok)(api_state)) resolve(api_state.Ok);
            else reject(api_state.Err);
        });
    }
}



var $3pMtJ = parcelRequire("3pMtJ");

var $5m6zs = parcelRequire("5m6zs");
function $cf3c121ebc4e8456$export$28caa12fec3053a3(props) {
    const [game, setGame] = (0, $acw62.useState)(null);
    const [ais, setAIs] = (0, $acw62.useState)(()=>{
        return [
            {
                proportion: (0, $mDWTX.processProportionDictionary)(7),
                randomness: (0, $mDWTX.processAIRandomness)(6)
            }
        ];
    });
    if (game == null) return /*#__PURE__*/ (0, $ayMG0.jsx)("dialog", {
        open: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "new-game",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5m6zs.Lobby), {
                    players: [
                        "Player"
                    ],
                    ais: ais,
                    addAI: (x)=>{
                        ais.push(x);
                        setAIs(ais.slice());
                    },
                    deleteAI: (i)=>{
                        let filtered_ais = ais.filter((_x, j)=>{
                            return i != j;
                        });
                        setAIs(filtered_ais);
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "flex-container",
                    style: {
                        paddingTop: "1em"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: ()=>{
                            const seed = new Date().getTime();
                            const game_wasm = new (0, $28275cec89eb94a7$export$9ed775f32f831ad8)(BigInt(seed), props.dictionary_text, ais);
                            const game = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3pMtJ.Game), {
                                settings: props.settings,
                                api: game_wasm,
                                end_game_fn: ()=>setGame(null)
                            }, seed);
                            setGame(game);
                        },
                        children: "New Game"
                    })
                })
            ]
        })
    });
    else return game;
}
var $77dc25903f6147a8$exports = {};
$77dc25903f6147a8$exports = import.meta.resolve("bK03c");


// @ts-ignore
const $cf3c121ebc4e8456$var$dictionary_url = new URL($77dc25903f6147a8$exports);
let $cf3c121ebc4e8456$var$dictionary_text = null;
async function $cf3c121ebc4e8456$var$run() {
    // First up we need to actually load the wasm file, so we use the
    // default export to inform it where the wasm file is located on the
    // server, and then we wait on the returned promise to wait for the
    // wasm to be loaded.
    //
    // It may look like this: `await init('./pkg/without_a_bundler_bg.wasm');`,
    // but there is also a handy default inside `init` function, which uses
    // `import.meta` to locate the wasm file relatively to js file.
    //
    // Note that instead of a string you can also pass in any of the
    // following things:
    //
    // * `WebAssembly.Module`
    //
    // * `ArrayBuffer`
    //
    // * `Response`
    //
    // * `Promise` which returns any of the above, e.g. `fetch("./path/to/wasm")`
    //
    // This gives you complete control over how the module is loaded
    // and compiled.
    //
    // Also note that the promise, when resolved, yields the wasm module's
    // exports which is the same as importing the `*_bg` module in other
    // modes
    await (0, $e88f48828034b730$export$2e2bcd8739ae039)();
    // need to retrieve the dictionary.csv file as text
    if ($cf3c121ebc4e8456$var$dictionary_text == null) $cf3c121ebc4e8456$var$dictionary_text = await fetch($cf3c121ebc4e8456$var$dictionary_url).then((response)=>{
        return response.text();
    });
    const root = (0, $aRPiL.createRoot)(document.getElementById("root"));
    root.render(/*#__PURE__*/ (0, $ayMG0.jsx)($cf3c121ebc4e8456$export$28caa12fec3053a3, {
        dictionary_text: $cf3c121ebc4e8456$var$dictionary_text,
        settings: {
            trayLength: 7,
            playerName: "Player"
        }
    }));
}
$cf3c121ebc4e8456$var$run().catch((error)=>{
    console.error(error);
});


//# sourceMappingURL=singleplayer.9be6ad18.js.map
